import { useLocation } from 'react-router-dom';

// Returns true if the current path starts with /patients and is NOT followed by another /,
// which is the case for Patient Story (/patients/:id).
export default function useIsPortfolio() {
  const { pathname } = useLocation();

  return !!pathname.match(/\/patients(?!\/)/);
}
